<div class="c-form-field" [ngClass]="cssClass">
  <input type="text" [placeholder]="placeholder" required="required" name="text" [formControl]="control" />
  <div class="c-form-field__label">{{ label }}</div>
  <div class="c-form-field__msg -error" *ngIf="errorText">{{ errorText }}</div>
  <div class="c-form-field__icon" *ngIf="iconName">
    <p500-ui-icon name="iconName"></p500-ui-icon>
  </div>
</div>
